if (typeof Shopify === 'undefined') {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('Price updater script loaded.');
  // A queue to hold price elements that need to be updated.
  const priceUpdateQueue = [];
  let isUpdating = false;

  const processQueue = async () => {
    if (isUpdating || priceUpdateQueue.length === 0) {
      return;
    }
    isUpdating = true;

    const priceElement = priceUpdateQueue.shift();
    await updatePrice(priceElement);

    isUpdating = false;
    // Process the next item in the queue
    processQueue();
  };

  const enqueuePriceUpdate = (priceElement) => {
    const variantId = priceElement.dataset.variantId;
    if (variantId && !priceElement.dataset.priceUpdated) {
      priceElement.dataset.priceUpdated = 'true'; // Mark as processed
      priceUpdateQueue.push(priceElement);
      processQueue();
    }
  };

  const updatePrice = async (priceElement) => {
    const cardInformation = priceElement.closest('.card-information');
    let variantId;

    if (cardInformation) {
      variantId = cardInformation.dataset.variantId;
    } else {
      variantId = priceElement.dataset.variantId;
    }
    
    if (!variantId) {
        // Fallback for product pages that might not have the card structure
        const variantInput = document.querySelector('input[name="id"]');
        if(variantInput) {
            variantId = variantInput.value;
        } else {
             console.error('Could not find variant ID for price element:', priceElement);
             return;
        }
    }

    console.log(`Updating price for variant: ${variantId}`);

    try {
      // Add to cart to get the final price.
      const addToCartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      const cartData = await addToCartResponse.json();
      console.log(`Received response for variant ${variantId}:`, cartData);

      // Check if the add to cart was successful. A 422 error is a common response for sold-out variants.
      if (!addToCartResponse.ok) {
        console.error(`Failed to add variant ${variantId} to cart. Status: ${addToCartResponse.status}. Response:`, cartData.description || cartData.message);
        // We can't get the price, so we leave the original price and stop.
        return;
      }
      
      const itemsArray = Array.isArray(cartData) ? cartData : cartData.items;
      
      if (!itemsArray) {
        console.error(`Could not find items array in cart response for variant ${variantId}`);
        return;
      }

      const item = itemsArray.find((i) => i.variant_id == variantId);

      if (!item) {
        console.log(`Variant ${variantId} not found in cart after add. Possibly out of stock or other issue.`);
        // Even if the add call was "ok", the item might not be in the cart if there are complex rules.
        // We'll try to remove it just in case, then stop.
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 0 }),
        });
        return;
      }
      
      const { final_price, original_price, key } = item;

      // Immediately remove the item from the cart.
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });

      if (final_price < original_price) {
        priceElement.innerHTML = `
          <span style="text-decoration: line-through; opacity: .5; margin-right: 0.5rem;">
            ${Shopify.formatMoney(original_price, window.Shopify.money_format)}
          </span>
          <span>
            ${Shopify.formatMoney(final_price, window.Shopify.money_format)}
          </span>
        `;
      } else {
        priceElement.innerHTML = `
          <span>
            ${Shopify.formatMoney(final_price, window.Shopify.money_format)}
          </span>
        `;
      }
    } catch (error) {
      console.error(`Error updating price for variant ${variantId}:`, error);
      // Unmark so it can be tried again later if needed.
      priceElement.dataset.priceUpdated = 'false';
    }
  };

  const discoverDynamicPrices = (container) => {
    const priceElements = container.querySelectorAll('.dynamic-price');
    console.log(`Found ${priceElements.length} price elements to update.`);
    priceElements.forEach(enqueuePriceUpdate);
  };

  // Initial discovery on page load
  discoverDynamicPrices(document.body);

  // Use MutationObserver to find new elements loaded dynamically
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            discoverDynamicPrices(node);
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Handle variant changes on product pages
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail.variant;
    if (variant) {
      const productForm = event.target.closest('product-form, .product-popup, .product-card-wrapper');
      if (productForm) {
        const priceElement = productForm.querySelector('.dynamic-price');
        if (priceElement) {
          const cardInfo = priceElement.closest('.card-information');
          if (cardInfo) {
            cardInfo.dataset.variantId = variant.id;
          }
          priceElement.dataset.priceUpdated = 'false'; // Reset to allow update
          enqueuePriceUpdate(priceElement);
        }
      }
    }
  });
});
